module.exports = __webpack_public_path__ + "static/img/xgoods.ce7384c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dm/xgoods.png
// module id = 0niO
// module chunks = 0